import { Theme } from "../../../components/constants";

export default {
    grid: { 
        padding: '30px 10px' 
    },
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    filterRow: {
        display: 'flex', 
        gap: '20px'
    },
    refColor: {
        color: '#257cc3'
    },
    linkHover: {
        cursor: 'pointer'
    }
}